<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>No coração do Brasil</h2>
          <p>
            A idealização de Brasília (DF) foi um dos marcos do governo JK. José
            Batista Sobrinho (JBS), que ficaria conhecido como Zé Mineiro,
            aproveitou a oportunidade e se tornou um dos primeiros fornecedores
            de carne bovina para os trabalhadores que construíam a capital no
            coração do Brasil.
          </p>
          <img
            src="../assets/img/1957/1957-1.jpg"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1960/04/21/g/19600421-26066-nac-0084-999-84-2cl-phwkkqk.jpg'
              )
            "
          />
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/1957/1957-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1970/03/25/g/19700325-29121-nac-0015-agr-6-not-ksaagax.jpg'
              )
            "
            class="fistItem"
          />
          <img
            src="../assets/img/1957/1957-3.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1956/10/19/g/19561019-24990-nac-0028-999-12-not-xwgqxxh.jpg'
              )
            "
            class="secondItem"
          />
          <img
            src="../assets/img/1957/1957-4.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1953/04/16/g/19530416-23904-nac-0009-999-9-not-gxhqxeg.jpg'
              )
            "
            class="terceiroItem"
          />
          <img
            src="../assets/img/1957/1957-5.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/1969/04/30/g/19690430-28851-nac-0050-agr-14-not-hqsasww.jpg'
              )
            "
            class="span2"
          />
          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
        <div class="formato__warpper__item--black">
          <h2>Construindo a indústria da pecuária</h2>
          <p>
            Brasília foi uma das muitas cidades que cresceram ao longo dos anos
            1950 e 1960. Para atender o novo mercado consumidor e estimular a
            pecuária, agricultores brasileiros importam da África o
            <strong>capim braquiária</strong>, que se desenvolveu bem no bioma
            do nosso cerrado nos anos seguintes. Novas regras e entidades
            começaram a dar segurança jurídica para o desenvolvimento da
            indústria de alimentos do País.
          </p>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    openLink(link) {
      window.open(link, "_blank");
    },
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 560px 1fr 255px;
    gap: 10px;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;

    &__item {
      position: relative;
      @include media("<=desktop") {
        padding: 0 20px;
      }
      &--image {
        display: grid;
        position: relative;
        grid-template-columns: 1fr 1fr;
        padding: 0 20px;
        gap: 10px;
        @include media(">desktop") {
          max-height: 705px;
          padding-top: 26px;
          margin-left: -110px;
          padding: 0;
          gap: 0;

          .span2 {
            grid-column: span 2;
            margin-top: 20px;
          }
          .fistItem {
            grid-column: 2;
            margin-left: -100px;
          }
          .secondItem {
            margin-top: -50px;
          }
          .terceiroItem {
            margin-top: 30px;
            margin-left: 20px;
          }
          .negativo {
            margin-left: -90px;
            margin-top: auto;
          }
        }
        span {
          position: absolute;
          left: -70px;
          bottom: 50px;
          width: 65px;
          color: color(cBlue4);
          @include media("<=desktop") {
            left: initial;
            right: 50px;
            bottom: 120px;
          }
          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cGreen);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }

      &--black {
        padding-block: 50px;
        @include media("<=desktop") {
          padding: 30px;
          background: color(cGreen);
          margin: 0;
        }
        p {
          color: color(cText);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
        }
        h2 {
          color: color(cText);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-block: 10px;
        }
        blockquote {
          color: color(cBlue);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          margin: 10px 0;
          position: relative;
          &::before {
            content: "\e901";
            font-family: "icomoon" !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    @include media(">desktop") {
      &::after {
        content: "";
        background: color(cGreen);
        width: 45%;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        z-index: -1;
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
  }
}
</style>
